import { createRouter, createWebHistory } from "vue-router";
import AdminLayoutPage from "./pages/AdminLayoutPage.vue";
import AdminJimengSettingsPage from "./pages/AdminJimengSettingsPage.vue";
import AdminGoogleSettingsPage from "./pages/AdminGoogleSettingsPage.vue";
import AdminLoginPage from "./pages/AdminLoginPage.vue";
import AdminOrdersPage from "./pages/AdminOrdersPage.vue";
import AdminPaymentProductsPage from "./pages/AdminPaymentProductsPage.vue";
import AdminPetActionsPage from "./pages/AdminPetActionsPage.vue";
import AdminRegistrationLimitSettingsPage from "./pages/AdminRegistrationLimitSettingsPage.vue";
import AdminUsersPage from "./pages/AdminUsersPage.vue";
import AdminStripeSettingsPage from "./pages/AdminStripeSettingsPage.vue";
import AdminWechatAuthSettingsPage from "./pages/AdminWechatAuthSettingsPage.vue";
import AdminWechatMerchantSettingsPage from "./pages/AdminWechatMerchantSettingsPage.vue";
import { useAdminAuthStore } from "./stores/adminAuth";

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", redirect: "/admin/users" },
    { path: "/admin", redirect: "/admin/users" },
    { path: "/admin/login", component: AdminLoginPage },
    {
      path: "/admin",
      component: AdminLayoutPage,
      children: [
        { path: "users", component: AdminUsersPage },
        { path: "orders", component: AdminOrdersPage },
        { path: "payment-products", component: AdminPaymentProductsPage },
        { path: "pet-actions", component: AdminPetActionsPage },
        { path: "settings/wechat-merchant", component: AdminWechatMerchantSettingsPage },
        { path: "settings/wechat-auth", component: AdminWechatAuthSettingsPage },
        { path: "settings/stripe", component: AdminStripeSettingsPage },
        { path: "settings/google", component: AdminGoogleSettingsPage },
        { path: "settings/registration-limits", component: AdminRegistrationLimitSettingsPage },
        { path: "settings/jimeng", component: AdminJimengSettingsPage }
      ]
    }
  ]
});

router.beforeEach((to) => {
  const adminAuth = useAdminAuthStore();
  if (to.path !== "/admin/login" && !adminAuth.isLoggedIn) {
    return "/admin/login";
  }
  if (to.path === "/admin/login" && adminAuth.isLoggedIn) {
    return "/admin/users";
  }
  return true;
});
